import { render, staticRenderFns } from "./FixturesScreenshot.vue?vue&type=template&id=660f0a34&scoped=true"
import script from "./FixturesScreenshot.vue?vue&type=script&lang=js"
export * from "./FixturesScreenshot.vue?vue&type=script&lang=js"
import style0 from "./FixturesScreenshot.vue?vue&type=style&index=0&id=660f0a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f0a34",
  null
  
)

export default component.exports